import { FormControl, InputLabel, ListSubheader, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useActors } from '../../hooks/useWorkspace';
import { ActorChip } from './ActorChip';

type Props = {
    /** Actor key ("user:1" / "bot:3") or null. */
    value: string | null;
    onChange: (value: string | null) => void;
    size?: 'small' | 'medium';
    label?: string;
    disabled?: boolean;
};

export const AssigneeSelect = ({ value, onChange, size, label, disabled }: Props) => {
    const { t } = useTranslation();
    const { data: actors = [] } = useActors();
    const fieldLabel = label ?? t('workflow.assignee');
    const people = actors.filter((actor) => actor.type === 'user');
    const bots = actors.filter((actor) => actor.type === 'bot');
    const known = actors.some((actor) => actor.key === value);

    return (
        <FormControl fullWidth size={size} disabled={disabled}>
            <InputLabel>{fieldLabel}</InputLabel>
            <Select
                value={value && known ? value : ''}
                label={fieldLabel}
                displayEmpty={false}
                onChange={(event) => onChange(event.target.value ? String(event.target.value) : null)}
                renderValue={(selected) => <ActorChip actor={actors.find((actor) => actor.key === selected)} />}
            >
                <MenuItem value="">
                    <em>{t('workflow.unassigned')}</em>
                </MenuItem>
                {people.map((actor) => (
                    <MenuItem key={actor.key} value={actor.key}>
                        <ActorChip actor={actor} />
                    </MenuItem>
                ))}
                {bots.length > 0 && <ListSubheader>{t('bots.title')}</ListSubheader>}
                {bots.map((actor) => (
                    <MenuItem key={actor.key} value={actor.key}>
                        <ActorChip actor={actor} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
